import React, { useState } from 'react';
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js';
import { BsDownload } from 'react-icons/bs';

const ImportacaoProdutos = () => {
    const [sku, setSku] = useState('');
    const [produtos, setProdutos] = useState([]);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleSkuChange = (e) => {
        setSku(e.target.value);
    };

    const handleBuscarProduto = async () => {
        try {
            // Substitua pela sua API de busca de produtos por SKU
            const response = await apinode.get(`/erpflex/produtos/${sku}/${localStorage.idconta}`);

            if (response.data.length === 0) {
                setError('Nenhum produto encontrado.');
            } else {
                setProdutos(response.data);
                setError(null);
            }

            console.log(response.data);
        } catch (error) {
            setProdutos([]);
            setError('Falha ao buscar produtos.');
        }
    };

    const handleImportarProduto = async (produto) => {
        try {
            const response = await apinode.get(`/erpflex/importar/${produto.codigo}/${localStorage.idconta}`);
            if (response.status === 200) {
                setSuccess('Produto importado com sucesso!');
                setError(null);
            } else {
                setError('Falha ao importar o produto.');
                setSuccess(null);
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                setError('Produto já cadastrado.');
                setSuccess(null);
            } else {
                setError('Falha ao importar o produto.');
                setSuccess(null);
            }
        }
    };


    return (
        <>
            <Navbar />
            <Container className='mt-page'>
                <Row className="mt-5">
                    <Col md={{ span: 6, offset: 3 }}>
                        <h4 className="mb-4">Importação de Produtos</h4>
                        <input
                            type="text"
                            placeholder="Digite o SKU"
                            value={sku}
                            onChange={handleSkuChange}
                            className="form-control mb-2"
                        />
                        <Button variant="primary" onClick={handleBuscarProduto}>
                            Buscar Produto
                        </Button>
                        {error && <p className="text-danger mt-2">{error}</p>}
                        {produtos.length > 0 && (
                            <div>
                                <h4 className="mt-4">Produtos Encontrados</h4>
                                <Table striped hover style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr>
                                            <th>SKU</th>
                                            <th>Nome do Produto</th>
                                            <th>Preço</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produtos.map((produto) => (
                                            <tr key={produto.id}>
                                                <td>{produto.codigo}</td>
                                                <td>{produto.descricao}</td>
                                                <td>{produto.preco}</td>
                                                <td>
                                                    <Button variant="success" size="sm" onClick={() => handleImportarProduto(produto)} title="Importar">
                                                        <BsDownload />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        )}
                        {success && <p className="text-success mt-2">{success}</p>}
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default ImportacaoProdutos;
